module.exports = __webpack_public_path__ + "media/images/countrysquared/no-6a1fb7903c610523c4c1b03f736f4746.svg";